<div class="slideout-content">
    <!-- Modal to add new user starts-->
    <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
        <div class="modal-dialog">
            <form class="add-new-user modal-content pt-0" [formGroup]="kindForm">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="toggleSidebar('create-kind')">
                    ×
                </button>
                <div class="modal-header mb-1">
                    <h5 class="modal-title" id="exampleModalLabel">Tür {{kind ? 'Güncelle' : 'Ekle'}}</h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <div class="form-group">
                                <label for="kindName">Tür Adı</label>
                                <input type="text" formControlName="kindName" class="form-control"
                                    placeholder="Tür Adı Giriniz." />
                                <div *ngIf="kindForm.get('kindName').invalid">
                                    <small class="text-danger" *ngIf="kindForm.get('kindName').errors.required">Tür adı
                                        zorunludur.</small>
                                    <small class="text-danger" *ngIf="kindForm.get('kindName').errors.maxlength">Tür Adı
                                        en
                                        fazla 25 karakter olabilir.</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mb-1">
                            <div class="form-group">
                                <label for="kindNumber">Tür Numarası</label>
                                <input type="number" formControlName="kindNumber" class="form-control"
                                    placeholder="Tür Numarası Giriniz." />
                                <div *ngIf="kindForm.get('kindNumber').invalid">
                                    <small class="text-danger" *ngIf="kindForm.get('kindNumber').errors.required">Tür
                                        numarası
                                        zorunludur.</small>
                                    <small class="text-danger" *ngIf="kindForm.get('kindNumber').errors.min">Tür
                                        Numarası en az 1 olmalıdır.</small>
                                    <small class="text-danger" *ngIf="kindForm.get('kindNumber').errors.max">Tür
                                        Numarası en fazla 99999 olabilir.</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button type="submit" [disabled]="kindForm.invalid" class="btn btn-primary col-12 mb-1"
                        (click)="onSubmit()" rippleEffect>
                        {{ kind ? 'Güncelle' : 'Ekle' }}
                    </button>
                    <button type="reset" class="btn btn-outline-secondary col-12 mb-1"
                        (click)="toggleSidebar('create-kind')" rippleEffect>
                        İptal
                    </button>
                </div>
                <div class="col-12 table-responsive">
                    <h4>Tür Bilgeleri</h4>
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Tür Adı</th>
                                <th>Tür No</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Hesaplar</td>
                                <td>7</td>
                            </tr>
                            <tr>
                                <td>Aksyion Türü</td>
                                <td>10</td>
                            </tr>
                            <tr>
                                <td>Masraflar</td>
                                <td>11</td>
                            </tr>
                            <tr>
                                <td>İzin Türleri</td>
                                <td>12</td>
                            </tr>
                            <tr>
                                <td>Cihaz Türleri</td>
                                <td>13</td>
                            </tr>
                            <tr>
                                <td>Cihaz Hareket Türleri</td>
                                <td>14</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </form>
        </div>
    </div>
    <!-- Modal to add new user Ends-->
</div>